define([
    'jquery',
    './globals',
    './helpers/console',
], function ($, globals, console) {
    'use strict';

    var RECAPTCHA_SITE_KEY = (globals && globals.recaptchaSiteKey) || '6LffjhEsAAAAADlUMxihEOgBsGJB500gEw4AEsGy';
    var recaptchaScriptLoadingPromise = null;

    /**
     * Dynamically loads reCAPTCHA v3 script once (similar to load-google-maps-api pattern).
     */
    var loadRecaptchaScript = function (lang) {
        // If grecaptcha is already present, do nothing.
        if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha.execute) {
            return $.Deferred().resolve().promise();
        }

        // If already loading, reuse the same promise.
        if (recaptchaScriptLoadingPromise) {
            return recaptchaScriptLoadingPromise;
        }

        var dfd = $.Deferred();
        var script = document.createElement('script');
        var src = 'https://www.google.com/recaptcha/api.js?render=' +
            encodeURIComponent(RECAPTCHA_SITE_KEY);

        if (lang) {
            src += '&hl=' + encodeURIComponent(lang);
        }

        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = function () {
            dfd.resolve();
        };
        script.onerror = function () {
            dfd.reject(new Error('Failed to load reCAPTCHA script'));
        };

        document.head.appendChild(script);
        recaptchaScriptLoadingPromise = dfd.promise();

        return recaptchaScriptLoadingPromise;
    };

    /**
     * Requests a reCAPTCHA v3 token for given action.
     */
    var getRecaptchaToken = function (action, lang) {
        var dfd = $.Deferred();

        loadRecaptchaScript(lang)
            .done(function () {
                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: action})
                        .then(function (token) {
                            if (!token) {
                                dfd.reject(new Error('Empty reCAPTCHA token'));
                                return;
                            }
                            dfd.resolve(token);
                        })
                        .catch(function (err) {
                            dfd.reject(err);
                        });
                });
            })
            .fail(function (err) {
                dfd.reject(err);
            });

        return dfd.promise();
    };

    var isValidEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    var autoExpand = function (field) {
        // Reset field height
        field.style.height = 'inherit';

        // Get the computed styles for the element
        var computed = window.getComputedStyle(field);

        // Calculate the height
        var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
            + parseInt(computed.getPropertyValue('padding-top'), 10)
            + field.scrollHeight
            + parseInt(computed.getPropertyValue('padding-bottom'), 10)
            + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

        field.style.height = height + 'px';
    };

    var init = function () {

        // autoExpand the text area as they type
        document.addEventListener('input', function (event) {
            if (event.target.tagName.toLowerCase() !== 'textarea') return;
            autoExpand(event.target);
        }, false);

        var $form = $('.js_form_seria'),
            $form_parent = $form.parent('.form__parent'),
            url = $form.attr('action'),
            hasError = false,
            data = {},

            // csrf
            $tokenInputField = $form.find('#token'),
            postTokenName = $tokenInputField.attr('name'),
            postTokenValue = $tokenInputField.val(),

            // form fields
            $names = $form.find('[name=names]'),
            $names_ = $form.find('[name=names_]'),
            $email = $form.find('[name=email]'),
            $phone = $form.find('[name=phone]'),
            $city = $form.find('[name=city]'),
            $message = $form.find('[name=message]'),
            $from_page = $form.find('[name=from_page]'),

            $consent = $form.find('[name=consent]'),
            $submit = $form.find('[name=submit]');

        $form.on('focus', 'input, textarea', function () {
            var $this = $(this);
            $this.removeClass('field_error');
        });

        $form.on('change', '[name=consent]', function () {
            $('.consent_wrap').removeClass('field_error');
        });

        $form.off('submit');
        $form.on('submit', function (event) {
            event.preventDefault();

            $form.find('.form-control').prop("disabled", true);
            $form.find('.error').remove();
            $form.find('.has-error').removeClass('has-error');
            $form.find('.field_error').removeClass('field_error');
            hasError = false;

            $submit.addClass('loading');

            if (!$consent.is(':checked')) {
                hasError = true;
                $('.consent_wrap').addClass('field_error');
                // $firstName.after("<span class='error'>The field is required</span>");
            }

            if ($names.val() === '') {
                hasError = true;
                $names.addClass('field_error');
                // $firstName.after("<span class='error'>The field is required</span>");
            }

            if (!isValidEmail($email.val())) {
                hasError = true;
                $email.addClass('field_error');
                // $email.after("<span class='error'>Please, enter valid email</span>");
            }

            if ($phone.val() === '') {
                hasError = true;
                $phone.addClass('field_error');
                // $phone.after("<span class='error'>The field is required</span>");
            }

            if (hasError) {
                $form.find('.form-control').prop("disabled", false);
                $submit.removeClass('loading');
                $form.prepend("<span class='error' style='padding: 10px 0;'>Попълнете задължителните полета!</span>");
                globals.goToByScroll($form_parent);

                return false;
            }

            data = {
                names: $names.val() || '',
                names_: $names_.val() || '',
                email: $email.val() || '',
                phone: $phone.val() || '',
                city: $city.val() || '',
                message: $message.val() || '',
                from_page: $from_page.val() || '',
                consent: $consent.val() || '',
                submit: $submit.val() || ''
            };


            var $recaptchaField = $form.find('[name=recaptcha_token]');
            var recaptchaAction = $form.data('recaptcha-action') || 'seria_form';
            var recaptchaErrorMessage = $form.data('recaptcha-error') ||
                'reCAPTCHA validation failed. Please, try again.'; // fallback EN

            var sendFormAjax = function () {
                $.ajax({
                    method: 'POST',
                    beforeSend: function (request) {
                        request.setRequestHeader('X-' + postTokenName, postTokenValue);
                    },
                    url: url,
                    data: data,
                    dataType: 'json'
                })
                    .done(function (json) {
                        $form.find('.error').remove();
                        $form.find('.has-error').removeClass('has-error');
                        $form.find('.field_error').removeClass('field_error');

                        if (json.error) {
                            $.each(json.errors, function (field, msg) {
                                if (field === 'form') {
                                    $form.prepend("<span class='error' style='padding: 10px 0;'>" + msg + "</span>");
                                    globals.goToByScroll($form_parent);
                                } else {
                                    var $field = $('#' + field);
                                    $field.addClass('field_error');
                                    $field.after("<span class='error'>" + msg + "</span>");
                                    globals.goToByScroll($field);
                                }
                            });
                        } else {
                            if (json.message) {
                                $form_parent.slideUp(400, function () {
                                    $form_parent.html(json.message);
                                    $form_parent.slideDown(300);
                                });
                            }
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        alert(textStatus, errorThrown);
                    })
                    .always(function () {
                        $form.find('.form-control').prop("disabled", false);
                        $submit.removeClass('loading');
                    });
            }

            // Language detection (BG default, EN secondary)
            var lang = $('html').attr('lang') || 'bg';

            // === reCAPTCHA v3 token retrieval (only after minor validations passed) ===
            getRecaptchaToken(recaptchaAction, lang)
                .done(function (token) {
                    // Validate presence of token before proceeding
                    if (!token) {
                        $form.find('.form-control').prop('disabled', false);
                        $submit.removeClass('loading');
                        $form.prepend("<span class='error'>" + recaptchaErrorMessage + "</span>");
                        globals.goToByScroll($form_parent);
                        return;
                    }

                    // Persist in hidden field so backend can read it
                    if (!$recaptchaField.length) {
                        $recaptchaField = $('<input>', {
                            type: 'hidden',
                            id: 'recaptcha_token',
                            name: 'recaptcha_token'
                        }).appendTo($form);
                    }
                    $recaptchaField.val(token);

                    // Also send as part of AJAX payload
                    data.recaptcha_token = token;

                    sendFormAjax();
                })
                .fail(function () {
                    $form.find('.form-control').prop('disabled', false);
                    $submit.removeClass('loading');
                    $form.prepend("<span class='error'>" + recaptchaErrorMessage + "</span>");
                    globals.goToByScroll($form_parent);
                });

        });
    };

    return {
        init: init
    };
});
